<template>
  <transition name="slide-down">
    <div v-if="!isOnline" class="offline-indicator">
      <i class="lni lni-signal mr-2"></i>
      You are offline. Khatm and Counter features require internet connection.
      <br />
      <small>Tasbih counter will continue to work offline.</small>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'OfflineIndicator',
  data() {
    return {
      isOnline: navigator.onLine
    };
  },
  mounted() {
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },
  methods: {
    updateOnlineStatus() {
      this.isOnline = navigator.onLine;
      
      if (this.isOnline) {
        this.$root.$bvToast.toast('You are back online!', {
          title: 'Connection Restored',
          autoHideDelay: 3000,
          variant: 'success',
        });
      }
    }
  }
};
</script>

<style scoped>
.offline-indicator {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #ff9800;
  color: white;
  padding: 12px 20px;
  text-align: center;
  z-index: 9999;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.offline-indicator small {
  font-size: 12px;
  opacity: 0.9;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease;
}

.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-100%);
}
</style>
